module.exports = __webpack_public_path__ + "img/covebuy.cccecfca.png";